import { createContext, useState } from "react";

//CTX's
export const ImageProjectCtx = () => {
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProj] = useState(0);
  const [show, setShow] = useState(false);
  return {
    selectedProject,
    setSelectedProj,
    projects,
    setProjects,
    show,
    setShow,
  };
};
export const ImageProjectContext = createContext({});
